(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cricket-programs-showcase"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const MODULE_KEY = 'CricketProgramsShowcaseModule';
    const SECTION_SELECTOR = '[data-cricket-programs]';
    const CARD_SELECTOR = '[data-cricket-program-card]';
    const instances = new WeakMap();

    function setActiveCard(root, activeCard) {
      root.querySelectorAll(CARD_SELECTOR).forEach((card) => {
        card.classList.toggle('is-active', card === activeCard);
      });
    }

    function initSection(root) {
      if (!root || instances.has(root)) return;

      const cards = Array.from(root.querySelectorAll(CARD_SELECTOR));
      if (!cards.length) return;

      const cleanup = [];
      const mobileQuery = window.matchMedia('(max-width: 989px)');

      const handleClick = (event) => {
        if (!mobileQuery.matches) return;

        const card = event.target.closest(CARD_SELECTOR);
        if (!card || !root.contains(card)) return;

        if (event.target.closest('a, button, input, select, textarea')) return;
        setActiveCard(root, card);
      };

      const handleFocus = (event) => {
        const card = event.target.closest(CARD_SELECTOR);
        if (card && root.contains(card)) setActiveCard(root, card);
      };

      root.addEventListener('click', handleClick);
      root.addEventListener('focusin', handleFocus);

      cleanup.push(() => root.removeEventListener('click', handleClick));
      cleanup.push(() => root.removeEventListener('focusin', handleFocus));

      let observer = null;

      const createObserver = () => {
        observer?.disconnect();
        observer = null;

        if (!mobileQuery.matches || !('IntersectionObserver' in window)) {
          cards.forEach((card) => card.classList.remove('is-active'));
          return;
        }

        observer = new IntersectionObserver(
          (entries) => {
            const visible = entries
              .filter((entry) => entry.isIntersecting)
              .sort((a, b) => b.intersectionRatio - a.intersectionRatio);

            if (visible[0]) setActiveCard(root, visible[0].target);
          },
          {
            root: null,
            rootMargin: '-28% 0px -42% 0px',
            threshold: [0.2, 0.45, 0.7],
          }
        );

        cards.forEach((card) => observer.observe(card));
        setActiveCard(root, cards[0]);
      };

      const handleBreakpoint = () => createObserver();

      if (mobileQuery.addEventListener) {
        mobileQuery.addEventListener('change', handleBreakpoint);
        cleanup.push(() => mobileQuery.removeEventListener('change', handleBreakpoint));
      } else {
        mobileQuery.addListener(handleBreakpoint);
        cleanup.push(() => mobileQuery.removeListener(handleBreakpoint));
      }

      createObserver();
      cleanup.push(() => observer?.disconnect());

      instances.set(root, () => cleanup.forEach((fn) => fn()));
    }

    function destroySection(root) {
      const destroy = instances.get(root);
      if (destroy) destroy();
      instances.delete(root);
    }

    function initAll(scope = document) {
      if (scope.matches?.(SECTION_SELECTOR)) initSection(scope);
      scope.querySelectorAll?.(SECTION_SELECTOR).forEach(initSection);
    }

    if (!window[MODULE_KEY]) {
      window[MODULE_KEY] = true;

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
      } else {
        initAll();
      }

      document.addEventListener('shopify:section:load', (event) => initAll(event.target));
      document.addEventListener('shopify:section:unload', (event) => {
        const root = event.target.matches?.(SECTION_SELECTOR)
          ? event.target
          : event.target.querySelector?.(SECTION_SELECTOR);

        if (root) destroySection(root);
      });
    } else {
      initAll();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-js-slider"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function () {
    
    const swiper = new Swiper("#heroSwiper", {
      loop: true,
      autoplay: {
        delay: 5500,
        disableOnInteraction: false
      },
      speed: 800,
      effect: "slide",
      pagination: {
        el: ".swiper-pagination",
        clickable: true
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
      },
      grabCursor: true,
      on: {
        init: function () {
          animateSlide(this.slides[this.activeIndex]);
        },
        slideChangeTransitionStart: function () {
          resetAnimations(this.slides);
        },
        slideChangeTransitionEnd: function () {
          animateSlide(this.slides[this.activeIndex]);
        }
      }
    });

    function resetAnimations(slides) {
      slides.forEach(slide => {
        const content = slide.querySelector(".hero-content");
        const btn = slide.querySelector(".hero-btn");
        if (content) content.classList.remove("animate-in");
        if (btn) btn.classList.remove("animate-in");
      });
    }

    function animateSlide(slide) {
      const content = slide.querySelector(".hero-content");
      const btn = slide.querySelector(".hero-btn");

      setTimeout(() => {
        if (content) content.classList.add("animate-in");
        if (btn) btn.classList.add("animate-in");
      }, 200); // delay for smoother effect
    }

  });

  } catch(e) { console.error(e); }
})();
})();
